<template>
  <div v-if="visible" class="modal-backdrop-custom">
    <div
      class="modal-dialog modal-dialog-centered"
      :style="{ maxWidth: mode === 'login' ? 'modal-sm' : 'modal-md' }"
    >
      <div
        class="modal-content shadow-lg border-0 rounded-4 bg-white p-3 p-md-4"
      >
        <!-- Header with Close Button -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5
            v-if="mode === 'login'"
            class="modal-title w-100 text-center fw-bold"
            style="color: #96000c"
          >
            {{ $t("navbar.login") }}
          </h5>
          <h5
            v-if="mode === 'register'"
            class="modal-title w-100 text-center fw-bold"
            style="color: #96000c"
          >
            {{ $t("LoginForm.customerregistration") }}
          </h5>
          <h5
            v-if="mode === 'forgot'"
            class="modal-title w-100 text-center fw-bold"
            style="color: #96000c"
          >
            {{ $t("LoginForm.forgotpassword") }}
          </h5>
          <h5
            v-if="mode === 'codeSent'"
            class="modal-title w-100 text-center fw-bold"
            style="color: #96000c"
          >
            {{ $t("LoginForm.code") }}
          </h5>
          <h5
            v-if="mode === 'resetPassword'"
            class="modal-title w-100 text-center fw-bold"
          >
            {{ $t("LoginForm.resetPassword") }}
          </h5>

          <button type="button" class="btn-close" @click="close"></button>
        </div>

        <!-- Login Form -->
        <form
          v-if="mode === 'login'"
          @submit.prevent="handleLogin"
          class="auth-form"
        >
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <!-- Phone Number -->
          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.phoneNumber")
            }}</label>
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-phone-fill fs-4"></i>
              </span>
              <input
                v-model="phoneNumber"
                type="tel"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.phoneplaceholder')"
                required
                maxlength="10"
              />
            </div>
          </div>

          <!-- Password -->
          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.password")
            }}</label>
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-lock-fill fs-4"></i>
              </span>
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.passwordplaceholder')"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary border-0"
                @click="showPassword = !showPassword"
              >
                <i
                  :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
                  class="fs-4"
                ></i>
              </button>
            </div>
          </div>

          <!-- Remember Me + Forgot -->
          <div
            class="d-flex justify-content-between align-items-center mb-3 mt-2"
          >
            <div class="form-check-one mb-3">
              <input
                v-model="rememberMe"
                class="form-check-input-one"
                type="checkbox"
                id="rememberMe"
              />
              <label class="form-check-label" for="rememberMe">
                {{ $t("LoginForm.remember") }}
              </label>
            </div>

            <a
              href="#"
              @click.prevent="mode = 'forgot'"
              class="text-decoration-none small"
              >{{ $t("LoginForm.forgot") }}</a
            >
          </div>

          <!-- Submit -->
          <button
            type="submit"
            class="btn btn-lg w-100 text-white fw-semibold"
            style="background-color: #96000c"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-else>
              <i class="bi bi-box-arrow-in-right me-2"></i>
              {{ $t("navbar.login") }}</span
            >
          </button>

          <!-- Switch to Register -->
          <div class="text-center mt-3">
            <span class="small">{{ $t("LoginForm.account") }}</span>
            <a
              href="#"
              class="fw-semibold ms-1 text-primary"
              @click.prevent="
                mode = 'register';
                clearData();
              "
            >
              {{ $t("LoginForm.register") }}
            </a>
          </div>
        </form>

        <!-- Register Form -->
        <form
          v-if="mode === 'register'"
          @submit.prevent="handleRegister"
          class="auth-form"
        >
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <!-- Phone Number -->
          <div class="mb-4">
            <!-- <label class="form-label fw-semibold">{{
              $t("LoginForm.phoneNumber")
            }}</label> -->
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-phone-fill fs-4"></i>
              </span>
              <input
                v-model="phoneNumber"
                type="tel"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.phoneplaceholder')"
                required
                maxlength="10"
              />
            </div>
          </div>

          <!-- Password -->
          <div class="mb-4">
            <!-- <label class="form-label fw-semibold">{{
              $t("LoginForm.password")
            }}</label> -->
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-lock-fill fs-4"></i>
              </span>
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.passwordplaceholder')"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary border-0"
                @click="showPassword = !showPassword"
              >
                <i
                  :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
                  class="fs-4"
                ></i>
              </button>
            </div>
            <div
              v-if="password && password.length < 6"
              class="text-danger small mt-1"
            >
              {{ $t("LoginForm.passwordslengh") }}
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="mb-4">
            <!-- <label class="form-label fw-semibold">{{
              $t("LoginForm.confirmpassword")
            }}</label> -->
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-lock-fill fs-4"></i>
              </span>
              <input
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.confirmpasswordplaceholder')"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary border-0"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <i
                  :class="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
                  class="fs-4"
                ></i>
              </button>
            </div>
            <div
              v-if="confirmPassword && password !== confirmPassword"
              class="text-danger small mt-1"
            >
              {{ $t("LoginForm.passwordsmatch") }}
            </div>
          </div>

          <!-- Terms -->
          <div class="form-check mb-3">
            <input
              v-model="termsAgreed"
              class="form-check-input-one"
              type="checkbox"
              id="agreeLicense"
              required
            />
            <label class="form-check-label" for="agreeLicense">
              {{ $t("PaymentPage.I_AGREE") }}
              <a
                href="terms-conditions"
                class="terms-link"
                style="color: #96000c"
              >
                {{ $t("PaymentPage.TERMS_AND_CONDITIONS") }}
              </a>
              {{ $t("PaymentPage.SERVICE_ABOOD") }}
            </label>
          </div>
          <button
            type="submit"
            class="btn btn-lg w-100 text-white fw-semibold"
            :disabled="!termsAgreed || loading"
            style="background-color: #96000c; border-color: #96000c"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-else> {{ $t("LoginForm.register") }} </span>
          </button>

          <!-- Actions -->
          <div class="d-flex justify-content-end gap-2">
            <!-- <button
              type="button"
              class="btn btn-secondary btn"
              @click="
                close();
                mode = 'login';
              "
            >
              {{ $t("LoginForm.cancel") }}
            </button> -->
            <!-- <button
              type="submit"
              class="btn btn-primary btn"
              :disabled="!termsAgreed || loading"
              style="background-color: #96000c; border-color: #96000c"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else> {{ $t("LoginForm.register") }} </span>
            </button> -->
          </div>

          <!-- Switch to Login -->
          <div class="text-center mt-3">
            <span class="small">{{ $t("LoginForm.accountregister") }}</span>
            <a
              href="#"
              class="fw-semibold ms-1 text-primary"
              @click.prevent="
                mode = 'login';
                clearData();
              "
            >
              {{ $t("navbar.login") }}
            </a>
          </div>
        </form>

        <!-- Forgot Password Form -->
        <form
          v-if="mode === 'forgot'"
          @submit.prevent="handleForgotPassword"
          class="auth-form"
        >
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.phoneNumber")
            }}</label>
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-phone-fill fs-4"></i>
              </span>
              <input
                v-model="phoneNumber"
                type="tel"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.phoneplaceholder')"
                required
                maxlength="10"
              />
            </div>
          </div>

          <!-- Actions -->
          <div class="d-flex justify-content-center gap-2">
            <button
              type="submit"
              class="btn btn-primary btn col-7"
              :disabled="loading"
              style="background-color: #96000c; border-color: #96000c"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else> {{ $t("LoginForm.send") }} </span>
            </button>
          </div>

          <!-- Back to Login -->
          <div class="text-center mt-3">
            <span class="small">{{ $t("LoginForm.backtologin") }}</span>
            <a
              href="#"
              class="fw-semibold ms-1 text-primary"
              @click.prevent="
                mode = 'login';
                clearData();
              "
            >
              {{ $t("navbar.login") }}
            </a>
          </div>
        </form>

        <!-- OTP Verification Form -->
        <form
          v-if="mode === 'codeSent'"
          @submit.prevent="handleVerifyCode"
          class="auth-form"
        >
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <div class="text-center mb-3">
            <span class="small"
              >{{ $t("LoginForm.codeSent") }} {{ phoneNumber }}</span
            >
          </div>

          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.verificationCode")
            }}</label>
            <div class="d-flex justify-content-center gap-2">
              <input
                v-for="(digit, index) in 6"
                :key="index"
                type="text"
                maxlength="1"
                class="form-control text-center fs-4 bg-light rounded"
                style="width: 45px; height: 55px"
                v-model="verificationDigits[index]"
                @input="moveNext($event, index)"
                @keydown.backspace="movePrev($event, index)"
                required
              />
            </div>
          </div>

          <!-- Resend Timer -->
          <div class="row">
            <div class="text-muted small mt-3 text-center">
              <span v-if="resendCountdown > 0">
                {{ $t("LoginForm.sendin") }} {{ resendCountdown }}s
              </span>
              <a
                v-else
                href="#"
                class="fw-semibold text-primary"
                @click.prevent="resendCode"
              >
                {{ $t("LoginForm.resendCode") }}
              </a>
            </div>

            <div class="d-flex justify-content-center gap-2 mt-3">
              <button
                type="submit"
                class="btn btn-primary btn col-7"
                :disabled="loading"
                style="background-color: #96000c; border-color: #96000c"
              >
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span v-else> {{ $t("LoginForm.submit") }} </span>
              </button>
            </div>

            <div class="text-center mt-3">
              <a
                href="#"
                class="fw-semibold text-primary"
                @click.prevent="mode = 'forgot'"
              >
                {{ $t("LoginForm.changeNumber") }}
              </a>
            </div>
          </div>
        </form>

        <!-- Reset Password Form -->
        <form
          v-if="mode === 'resetPassword'"
          @submit.prevent="handleResetPassword"
          class="auth-form"
        >
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <!-- New Password -->
          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.newPassword")
            }}</label>
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-lock-fill fs-4"></i>
              </span>
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.newPasswordPlaceholder')"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary border-0"
                @click="showPassword = !showPassword"
              >
                <i
                  :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
                  class="fs-4"
                ></i>
              </button>
            </div>
            <div
              v-if="password && password.length < 6"
              class="text-danger small mt-1"
            >
              {{ $t("LoginForm.passwordslengh") }}
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="mb-4">
            <label class="form-label fw-semibold">{{
              $t("LoginForm.confirmpassword")
            }}</label>
            <div class="input-group input-group-lg bg-light rounded">
              <span class="input-group-text bg-white border-0">
                <i class="bi bi-lock-fill fs-4"></i>
              </span>
              <input
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                class="form-control border-0 bg-light fs-5"
                :placeholder="$t('LoginForm.confirmpasswordplaceholder')"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary border-0"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <i
                  :class="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"
                  class="fs-4"
                ></i>
              </button>
            </div>
            <div
              v-if="confirmPassword && password !== confirmPassword"
              class="text-danger small mt-1"
            >
              {{ $t("LoginForm.passwordsmatch") }}
            </div>
          </div>

          <!-- Actions -->
          <div class="d-flex justify-content-center gap-2">
            <button
              type="submit"
              class="btn btn-primary btn col-7"
              :disabled="loading"
              style="background-color: #96000c; border-color: #96000c"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else> {{ $t("LoginForm.resetPassword") }} </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, watch } from "vue";
import identity from "@/services/identity";
// import { useRouter } from "vue-router";
import { useStore } from "vuex";
// const router = useRouter();
const store = useStore();

defineProps({ visible: Boolean });
const emit = defineEmits(["close", "login-success"]);

// Aliased so the call sites below read unchanged. The shared instance
// carries the v2 base URL and unwraps the { ok, code, message, data }
// envelope, so `response.data.access_token` still works.
const axiosInstance = identity;

// Reactive state
const mode = ref("login");
const loading = ref(false);
const errorMessage = ref("");
const phoneNumber = ref("");
const password = ref("");
const confirmPassword = ref("");
const rememberMe = ref(false);
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const termsAgreed = ref(false);
const verificationDigits = ref(Array(6).fill(""));
const resendCountdown = ref(0);
const userId = ref("");
const authToken = ref("");
const isPasswordReset = ref(false);

// Computed properties
const verificationCode = computed(() => verificationDigits.value.join(""));
const passwordsMatch = computed(() => password.value === confirmPassword.value);

// Watch for mode changes
watch(mode, (newMode) => {
  if (newMode === "codeSent") {
    startResendCountdown();
  }
});

// Methods
function close() {
  emit("close");
  resetForm();
}

function resetForm() {
  mode.value = "login";
  phoneNumber.value = "";
  password.value = "";
  confirmPassword.value = "";
  rememberMe.value = false;
  termsAgreed.value = false;
  verificationDigits.value = Array(6).fill("");
  errorMessage.value = "";
  userId.value = "";
  authToken.value = "";
  isPasswordReset.value = false;
}

function clearData() {
  phoneNumber.value = "";
  password.value = "";
  confirmPassword.value = "";
  errorMessage.value = "";
}

function showError(message) {
  errorMessage.value = message;
  setTimeout(() => {
    errorMessage.value = "";
  }, 5000);
}

function moveNext(event, index) {
  const value = event.target.value;
  if (value && index < 5) {
    const nextInput =
      event.target.parentElement.parentElement.querySelectorAll("input")[
        index + 1
      ];
    nextInput.focus();
  }

  // Auto submit if all digits are filled
  if (index === 5 && value) {
    const allFilled = verificationDigits.value.every((digit) => digit !== "");
    if (allFilled) {
      handleVerifyCode();
    }
  }
}

function movePrev(event, index) {
  if (
    event.key === "Backspace" &&
    !verificationDigits.value[index] &&
    index > 0
  ) {
    const prevInput =
      event.target.parentElement.parentElement.querySelectorAll("input")[
        index - 1
      ];
    prevInput.focus();
  }
}

function startResendCountdown() {
  resendCountdown.value = 60;
  const timer = setInterval(() => {
    if (resendCountdown.value > 0) {
      resendCountdown.value--;
    } else {
      clearInterval(timer);
    }
  }, 1000);
}

async function resendCode() {
  if (resendCountdown.value > 0) return;

  loading.value = true;
  try {
    if (isPasswordReset.value) {
      await axiosInstance.post("auth/resend-password-reset", {
        username: phoneNumber.value,
      });
    } else {
      await axiosInstance.post(
        "auth/resend-verification",
        {
          user_id: userId.value,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken.value}`,
          },
        }
      );
    }
    startResendCountdown();
  } catch (error) {
    showError(error.response?.data?.message || "Failed to resend code");
  } finally {
    loading.value = false;
  }
}

async function handleLogin() {
  loading.value = true;
  try {
    const response = await axiosInstance.post("auth/login", {
      username: phoneNumber.value,
      password: password.value,
      rememberMe: rememberMe.value,
    });

    const data = response.data;

    if (data.requires_verification) {
      // Requires OTP verification
      userId.value = data.user_id;
      authToken.value = data.access_token;
      mode.value = "codeSent";
      startResendCountdown();
    } else if (data.access_token) {
      // Login successful
      store.dispatch("login", {
        token: data.access_token,
        user: data.user,
      });
      // localStorage.setItem("auth_token", data.access_token);
      // localStorage.setItem("user", JSON.stringify(data.user));
      // The access token and the user object were printed here. Vue CLI does
      // not strip console calls (no terser drop_console in vue.config.js), so
      // both shipped in the production bundle: anyone opening devtools on a
      // shared or borrowed phone could read a token that never expires.
      emit("login-success", data.user);

      close();
      // router.push("/");
      window.location.href = "/";
    } else {
      showError("Login failed. Please try again.");
    }
  } catch (error) {
    showError(
      error.response?.data?.message || "Login failed. Please try again."
    );
  } finally {
    loading.value = false;
  }
}

async function handleRegister() {
  if (!passwordsMatch.value) {
    showError("Passwords do not match");
    return;
  }

  if (password.value.length < 8) {
    showError("Password must be at least 8 characters");
    return;
  }

  loading.value = true;
  try {
    const response = await axiosInstance.post("auth/register", {
      username: phoneNumber.value,
      password: password.value,
      password_confirmation: confirmPassword.value,
      customer_type: "PASSENGER",
    });

    const data = response.data;

    if (data.requires_verification) {
      // Requires OTP verification
      userId.value = data.user_id;
      authToken.value = data.access_token;
      mode.value = "codeSent";
      startResendCountdown();
    } else if (data.access_token) {
      // Registration successful
      store.dispatch("login", {
        token: data.access_token,
        user: data.user,
      });
      // localStorage.setItem("auth_token", data.access_token);
      // localStorage.setItem("user", JSON.stringify(data.user));
      window.location.href = "/";
      emit("login-success", data.user);
      close();
    } else {
      showError("Registration failed. Please try again.");
    }
  } catch (error) {
    showError(
      error.response?.data?.message || "Registration failed. Please try again."
    );
  } finally {
    loading.value = false;
  }
}

async function handleForgotPassword() {
  loading.value = true;
  try {
    const response = await axiosInstance.post("auth/forgot-password", {
      username: phoneNumber.value,
    });

    const data = response.data;

    if (data.ok) {
      userId.value = data.user_id;
      isPasswordReset.value = true;
      mode.value = "codeSent";
      startResendCountdown();
    } else {
      showError(data.message || "Failed to send reset instructions");
    }
  } catch (error) {
    showError(
      error.response?.data?.message || "Failed to send reset instructions"
    );
  } finally {
    loading.value = false;
  }
}

async function handleVerifyCode() {
  loading.value = true;
  try {
    if (isPasswordReset.value) {
      // Verify password reset code
      const response = await axiosInstance.post("auth/verify-reset-code", {
        username: phoneNumber.value,
        verification_code: verificationCode.value,
      });

      const data = response.data;

      if (data.ok) {
        mode.value = "resetPassword";
      } else {
        showError(data.message || "Invalid verification code");
      }
    } else {
      // Verify phone number for registration/login
      const response = await axiosInstance.post(
        "auth/verify-phone",
        {
          user_id: userId.value,
          verification_code: verificationCode.value,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken.value}`,
          },
        }
      );

      const data = response.data;

      if (data.access_token) {
        store.dispatch("login", {
          token: data.access_token,
          user: data.user,
        });
        // localStorage.setItem("auth_token", data.access_token);
        // localStorage.setItem("user", JSON.stringify(data.user));
        emit("login-success", data.user);
        close();
        window.location.href = "/";
      } else {
        showError(data.message || "Verification failed");
      }
    }
  } catch (error) {
    showError(error.response?.data?.message || "Verification failed");
  } finally {
    loading.value = false;
  }
}

async function handleResetPassword() {
  if (!passwordsMatch.value) {
    showError("Passwords do not match");
    return;
  }

  if (password.value.length < 8) {
    showError("Password must be at least 8 characters");
    return;
  }

  loading.value = true;
  try {
    const response = await axiosInstance.post("auth/reset-password", {
      username: phoneNumber.value,
      password: password.value,
      password_confirmation: confirmPassword.value,
      verification_code: verificationCode.value,
    });

    const data = response.data;

    if (data.ok) {
      // Password reset successful, go to login
      mode.value = "login";
      showError(
        "Password reset successfully. Please login with your new password."
      );
    } else {
      showError(data.message || "Password reset failed");
    }
  } catch (error) {
    showError(error.response?.data?.message || "Password reset failed");
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
/* ── BRAND OVERLAY ──────────────────────────────────────────────
 * Applies the page's token system on top of the existing bootstrap
 * markup so the modal reads as part of the redesigned site without
 * the heavy lift of rewriting the auth flow's template. Targets the
 * modal's existing class structure with brand colours, type, and
 * focus states.
 */
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  z-index: 1055;
  background-color: rgba(8, 12, 28, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: lm-fade .18s ease-out;
}
@keyframes lm-fade { from { opacity: 0; } to { opacity: 1; } }

.modal-dialog {
  width: 100%;
  max-width: 440px;
  animation: lm-rise .22s cubic-bezier(.22,1,.36,1);
}
@keyframes lm-rise {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

.modal-content {
  border-radius: 20px !important;
  border: 1px solid var(--color-border, #e2e8f0) !important;
  padding: 28px !important;
  background: var(--color-surface, #fff) !important;
  box-shadow: 0 28px 60px rgba(8, 23, 49, 0.30) !important;
}

/* Brand the title — was hardcoded #96000c (off-brand maroon),
 * now matches the page's primary red accent. */
.modal-content :deep(.modal-title) {
  color: var(--color-red, #e11d48) !important;
  font: 800 18px/1.2 var(--font-sans, sans-serif) !important;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* Close button — bigger touch target, no bootstrap chrome */
.modal-content :deep(.btn-close) {
  width: 36px; height: 36px;
  background: var(--color-surface-2, #f8fafc);
  border: 1px solid var(--color-border, #e2e8f0);
  border-radius: 10px;
  opacity: 1;
  transition: background .15s, border-color .15s;
}
.modal-content :deep(.btn-close:hover) {
  background: var(--color-red-50, #fde7eb);
  border-color: rgba(225, 29, 72, 0.25);
}

/* Inputs */
.auth-form input,
.auth-form .input-group {
  height: 48px; /* smaller */
  font-size: 0.95rem;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.form-control:focus {
  border-color: #96000c;
  box-shadow: 0 0 6px rgba(150, 0, 12, 0.3);
}

/* Buttons */
.btn-primary {
  background-color: #96000c;
  border-color: #96000c;
  transition: 0.2s;
}

.btn-primary:hover {
  background-color: #7a000a;
  border-color: #7a000a;
}

.btn {
  border-radius: 8px;
  font-weight: 500;
}

.form-check-input {
  accent-color: #96000c;
}

.text-primary {
  color: #96000c !important;
}

.terms-link {
  color: #96000c;
  text-decoration: underline;
  font-weight: 500;
}

@media (max-width: 576px) {
  .modal-content {
    padding: 1.2rem !important;
    border-radius: 10px;
  }
  .auth-form input[type="checkbox"] {
    height: auto;
    width: auto;
  }
}

@media (max-width: 576px) {
  .modal-content {
    padding: 1rem !important;
    border-radius: 12px;
  }

  .auth-form input[type="checkbox"] {
    height: auto;
    width: auto;
  }
}

.form-check-input {
  accent-color: #96000c;
  border-radius: 0.25rem;
  cursor: pointer;
}
.form-check-input-one {
  accent-color: #96000c; /* brand color */
  border-radius: 0.25rem; /* smooth corners */
  cursor: pointer;
  width: 18px; /* standard size */
  height: 18px;
  margin-top: 0.2rem; /* align with label text */
  margin-right: 0.5rem;
  vertical-align: middle;
}

.form-check-label {
  font-size: 0.95rem;
  cursor: pointer;
  user-select: none;
}

.form-control {
  border: 2px solid #ccc;
  border-radius: 10px;
}

.form-control:focus {
  border-color: #96000c;
  box-shadow: 0 0 3px #96000c;
}

.btn-primary {
  background-color: #96000c;
  border-color: #96000c;
}

.btn-primary:hover {
  background-color: #7a000a;
  border-color: #7a000a;
}

.text-primary {
  /* Brand red — was off-brand maroon. */
  color: var(--color-red, #e11d48) !important;
}

.terms-link {
  color: var(--color-red, #e11d48);
  text-decoration: underline;
}

/* ── Form input treatment ─────────────────────────────────────── */
.modal-content :deep(.form-label) {
  font: 700 12px / 1 var(--font-sans, sans-serif) !important;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-text-2, #334155) !important;
  margin-bottom: 8px !important;
}
.modal-content :deep(.input-group) {
  background: var(--color-surface, #fff) !important;
  border: 1px solid var(--color-border, #e2e8f0) !important;
  border-radius: 12px !important;
  transition: border-color .15s, box-shadow .15s;
  overflow: hidden;
}
.modal-content :deep(.input-group:focus-within) {
  border-color: var(--color-red, #e11d48) !important;
  box-shadow: 0 0 0 3px rgba(225, 29, 72, 0.15);
}
.modal-content :deep(.input-group .input-group-text) {
  background: transparent !important;
  border: 0 !important;
  color: var(--color-muted, #64748b);
}
.modal-content :deep(.input-group .form-control) {
  background: transparent !important;
  border: 0 !important;
  padding-left: 0 !important;
  font: 600 15px / 1.2 var(--font-sans, sans-serif) !important;
  color: var(--color-text, #0f172a) !important;
}
.modal-content :deep(.input-group .form-control::placeholder) {
  color: var(--color-muted-2, #94a3b8) !important;
  font-weight: 500;
}
.modal-content :deep(.alert-danger) {
  background: var(--color-red-50, #fde7eb);
  color: var(--color-red-600, #be123c);
  border: 1px solid rgba(225, 29, 72, 0.25);
  border-radius: 10px;
  padding: 10px 14px;
  font: 600 13px / 1.4 var(--font-sans, sans-serif);
}

/* Primary submit buttons inside the auth form — bootstrap btn-primary
 * gets the brand red gradient + shadow halo. */
.modal-content :deep(.btn-primary),
.modal-content :deep(.btn-lg.btn-primary) {
  background: linear-gradient(135deg, var(--color-red, #e11d48) 0%, var(--color-red-600, #be123c) 100%) !important;
  border: 0 !important;
  border-radius: 12px !important;
  padding: 12px 18px !important;
  font: 800 13px / 1 var(--font-sans, sans-serif) !important;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 8px 18px rgba(225, 29, 72, 0.35) !important;
  transition: box-shadow .2s, transform .05s !important;
}
.modal-content :deep(.btn-primary:hover) {
  box-shadow: 0 12px 24px rgba(225, 29, 72, 0.45) !important;
}
.modal-content :deep(.btn-primary:active) { transform: translateY(1px); }
.modal-content :deep(.btn-outline-secondary) {
  border: 0 !important;
  color: var(--color-muted, #64748b) !important;
  background: transparent !important;
}
.modal-content :deep(.btn-outline-secondary:hover) {
  color: var(--color-text, #0f172a) !important;
  background: var(--color-surface-2, #f8fafc) !important;
}

/* Form check (remember-me) */
.modal-content :deep(.form-check-input),
.modal-content :deep(.form-check-input-one) {
  border: 1.5px solid var(--color-border, #e2e8f0) !important;
  border-radius: 4px !important;
}
.modal-content :deep(.form-check-input:checked),
.modal-content :deep(.form-check-input-one:checked) {
  background-color: var(--color-red, #e11d48) !important;
  border-color: var(--color-red, #e11d48) !important;
}
</style>
